<lb-profile-info-box infoBoxIcon="untitled-ui/users/user-01" [formGroup]="form()">
	<lb-profile-image-loader left [userImage]="profile().userImage" (onFileChange)="setProfileImage($event)"></lb-profile-image-loader>
	<ng-content right>
		<lb-form-row>
			<lb-form-field>
				<label>First Name</label>
				<input type="text" md-form-input formControlName="firstName" />
			</lb-form-field>

			<lb-form-field>
				<label>Last Name</label>
				<input type="text" md-form-input formControlName="lastName" />
			</lb-form-field>
		</lb-form-row>

		<lb-form-row>
			<lb-form-field>
				<label>Preferred Name</label>
				<input type="text" md-form-input formControlName="preferredName" />
			</lb-form-field>

			<lb-form-field>
				<label>Date Of Birth</label>
				<input type="date" placeholder="YYYY-MM-DD" md-form-input md-date-picker-input formControlName="dateOfBirth" />
			</lb-form-field>
		</lb-form-row>

		<lb-form-row>
			<lb-form-field>
				<label>Pronouns</label>
				<md-drop-down [options]="pronounOptions()" placeholder="Make a selection..." formControlName="pronoun"></md-drop-down>
			</lb-form-field>

			<lb-form-field>
				<label>Gender</label>
				<md-drop-down [options]="genderOptions()" placeholder="Make a selection..." formControlName="gender"></md-drop-down>
			</lb-form-field>
		</lb-form-row>
	</ng-content>
</lb-profile-info-box>
